var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup383(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_383",
    "data-name": "Group 383",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.274,
    height: 22.04,
    viewBox: "0 0 22.274 22.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3768",
    "data-name": "Path 3768",
    d: "M-510.3,135.447c.2-.293.4-.561.579-.836a3.338,3.338,0,0,0-2.421-5.131A3.468,3.468,0,0,0-516,132.325a3.052,3.052,0,0,0,.5,2.234c.422.638.869,1.26,1.319,1.91-.5.32-.985.649-1.488.95a6.5,6.5,0,0,0-2.128,2.009c-.035.054-.074.106-.107.161a.7.7,0,0,0-.04.105,8.252,8.252,0,0,0,5.293,1.949v2.068c-.427-.028-.853-.032-1.271-.086a10.215,10.215,0,0,1-5.008-2.071,9.993,9.993,0,0,1-3.818-6.122,10.042,10.042,0,0,1,2.124-8.6,9.805,9.805,0,0,1,6.252-3.637A10.043,10.043,0,0,1-505,126.416a9.609,9.609,0,0,1,2.63,5.943c.079,1.009.013,2.03.013,3.064h-1.992c0-.095-.011-.188-.012-.282-.012-.791,0-1.583-.041-2.372a7.855,7.855,0,0,0-1.7-4.468,8,8,0,0,0-5.265-3.1,8.034,8.034,0,0,0-6.589,1.848,7.971,7.971,0,0,0-2.841,5.024,8.118,8.118,0,0,0,1.3,5.947.984.984,0,0,0,.068.077,8.324,8.324,0,0,1,2.281-2.229c-.1-.175-.21-.342-.306-.514a5.516,5.516,0,0,1,3.712-8.079,5.537,5.537,0,0,1,6.569,4.306,5.334,5.334,0,0,1-.564,3.72.336.336,0,0,1-.221.171c-.751.012-1.5.007-2.253.005A.429.429,0,0,1-510.3,135.447Z",
    transform: "translate(522.968 -123.042)",
    fill: "#4c5b71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3769",
    "data-name": "Path 3769",
    d: "M-256.222,438.366l2.136,2.152,4.358-4.358,1.462,1.484c-.021.022-.078.085-.138.145l-4.793,4.794a1.066,1.066,0,0,1-1.735,0l-2.624-2.615c-.05-.05-.1-.1-.13-.141Z",
    transform: "translate(270.54 -420.989)",
    fill: "#4c5b71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup383);
export default __webpack_public_path__ + "static/media/Group 383.4ccc3cab99e694b47dc2dc00c997990f.svg";
export { ForwardRef as ReactComponent };